<template>
  <div :class="$style.container">
    <Loading :loading="loading" text="">
      <Row>
        <Item title="转出状态">
          <el-select v-model="status" placeholder="请选择状态">
            <el-option
              v-for="(item, index) in statusList"
              :key="index"
              :label="item"
              :value="index + 1"
            />
          </el-select>
        </Item>

        <Item title="域名">
          <el-input v-model="domainName" placeholder="请选择状态" />
        </Item>

        <Button type="primary" :loading="loading" @click="submitSearch(1)">
          搜索
        </Button>

        <Button :class="$style.reset" @click="reset"> 重置 </Button>
      </Row>

      <Divider />

      <!-- 搜索列表 -->
      <Title title="转出列表" :count="total">
        <span :class="$style.title_tips">
          若您已在<span class="theme-color">新注册商接口</span>
          确认转入的前提下，请点击点“发送确认信”，发送转出确认邮件！
        </span>
      </Title>

      <el-table
        ref="multipleTable"
        :data="showList"
        :fit="true"
        border
        tooltip-effect="dark"
        style="width: 100%"
      >
        <el-table-column label="序号" width="50" align="center">
          <template slot-scope="scope">{{
            limit * (page - 1) + scope.$index + 1
          }}</template>
        </el-table-column>

        <el-table-column prop="name" label="域名" width="150" align="center" />
        <el-table-column
          prop="createdTime"
          label="提交时间"
          width="100"
          align="center"
        >
        </el-table-column>

        <el-table-column
          prop="transferStatus"
          label="转出状态"
          width="120"
          align="center"
        >
          <template slot-scope="scope">
            {{ statusList[scope.row.transferStatus - 1] || "" }}
          </template>
        </el-table-column>

        <el-table-column
          prop="expireTime"
          label="操作"
          width="120"
          align="center"
        >
          <template slot-scope="scope">
            <div :class="$style.table_actions">
              <template v-if="scope.row.transferStatus === 1">
                <span :class="$style.btn" @click="getCodeAgain(scope.row.id)">
                  重新获取转移码
                </span>
                <div :class="$style.btn" @click="deleteItem(scope.row.id)">
                  取消
                </div>
              </template>

              <template v-else-if="scope.row.status === 2">
                <span :class="$style.btn" @click="agreeItem(scope.row.id)"
                  >同意</span
                >
                <span :class="$style.btn" @click="deleteItem(scope.row.id)"
                  >取消</span
                >
                <span :class="$style.btn" @click="checkStatus(scope.row.id)">
                  查询状态
                </span>
              </template>

              <template
                v-else-if="scope.row.status === 4 && scope.row.reason !== null"
              >
                <span
                  :class="$style.btn"
                  @click="checkReason(scope.row.reason)"
                >
                  原因
                </span>
              </template>
              <template v-else>-</template>
            </div>
          </template>
        </el-table-column>
      </el-table>

      <el-pagination
        background
        layout="prev, pager, next"
        :current-page="page"
        :page-size="limit"
        :total="total"
        @current-change="handlePageChange"
      />
    </Loading>
  </div>
</template>

<script>
import {
  getTransferOutList,
  createCodeAgain,
  deleteTransferOut,
  agreeTransferOut,
  getTransferOutStatus,
} from "@server";
import Loading from "../../../components/global/Loading.vue";

export default {
  components: { Loading },
  name: "DomainRecord",
  data() {
    return {
      statusList: [
        "待转出",
        "转出中",
        "转出成功",
        "转出失败",
        "用户取消",
        "转入商拒绝",
      ],
      status: "",
      domainName: "",

      loading: false,
      page: 1,
      limit: 50,
      showList: [],
      total: 0,
    };
  },
  methods: {
    async submitSearch(page = 1) {
      this.loading = true;
      this.page = page;

      const params = {
        page,
        limit: this.limit,
      };
      this.status !== "" && (params.status = this.status);
      this.domainName !== "" && (params.name = this.domainName);
      const res = await getTransferOutList(params);
      const { code, data } = res;

      if (code === 200) {
        this.total = data.total;
        this.showList = data.list;
      }
      this.loading = false;
    },
    reset() {
      this.status = "";
      this.domainName = "";
      this.submitSearch();
    },

    getCodeAgain(id) {
      this.$confirm(`确定要重新获取转移码吗?`, "操作确认", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          this.loading = true;
          const res = await createCodeAgain({ id });

          if (res.code === 200) {
            this.$message({ message: "重新获取转移码成功!", type: "success" });
          }
          this.loading = false;
        })
        .catch(() => {});
    },

    deleteItem(id) {
      this.$confirm(`确定要取消此转出吗？`, "取消确认", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          this.loading = true;
          const res = await deleteTransferOut({ id });

          if (res.code === 200) {
            this.$message({ message: "取消成功!", type: "success" });
            this.submitSearch();
          }
          this.loading = false;
        })
        .catch(() => {});
    },

    agreeItem(id) {
      this.$confirm(`确定要同意此转出吗？`, "同意确认", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          this.loading = true;
          const res = await agreeTransferOut({ id });

          if (res.code === 200) {
            this.$message({ message: "同意成功!", type: "success" });
            this.submitSearch();
          }
          this.loading = false;
        })
        .catch(() => {});
    },

    async checkStatus(id) {
      const res = await getTransferOutStatus({ id });
      if (res.code == 200) {
        this.$alert(res.data || "-", "当前状态", {
          confirmButtonText: "确定",
        });
      }
    },

    checkReason(reason) {
      this.$alert(reason, "转出失败原因", {
        confirmButtonText: "确定",
      });
    },

    handlePageChange(page) {
      this.submitSearch(page);
    },
  },
  created() {
    this.submitSearch();
  },
};
</script>

<style lang="scss" module scoped>
.container {
  min-height: 300px;

  :global {
    .gl-row {
      padding-bottom: rem(50);
    }

    ::v-deep .gl-item {
      margin-right: 40px;

      .gl-item__left {
        min-width: unset;
      }
    }

    .el-input {
      width: rem(330);
    }

    .el-pagination {
      margin: rem(50) 0;
      @include flex();
    }
  }

  .title_tips {
    font-size: rem(14);
    font-weight: normal;
    color: #666;
    margin-left: 20px;
  }

  .table_actions {
    @include flex();
    gap: rem(20);

    .btn {
      cursor: pointer;
      font-size: rem(14);
      color: $theme-color;
    }
  }
}
</style>
